import React from "react";
import { useTranslation } from "react-i18next";
import { Input, Row, Col } from "reactstrap"; // Added Spinner


const NewsForm = ({ labels, formikProps, isAddOrEdit }) => {
    const { t, i18n } = useTranslation();

  // Destructure from formikProps for easier access
  const { values, errors, touched, handleChange, handleBlur } = formikProps;

  // Helpers to convert ISO strings to input-friendly local formats
  const pad = (v) => String(v).padStart(2, "0");
  const isIsoString = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:?/.test(v);

  const toLocalDate = (iso) => {
    if (!iso) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso; // already date
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const toLocalTime = (iso) => {
    if (!iso) return "";
    // Match HH:MM, HH:MM:SS, optionally followed by timezone offsets like +00 or +00:00
    const timeMatch = iso.toString().match(/^(\d{2}):(\d{2})(?::\d{2})?(?:[+\-].*)?$/);
    if (timeMatch) return `${timeMatch[1]}:${timeMatch[2]}`;
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
    
  const renderField = (item) => {
  const fieldValue = values[item.name] ?? "";
    
    switch (item.fieldName) {
      case "text-box":
        return (
          <Input
            type={"text"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "number":
        return (
          <Input
            type="tel"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange} 
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      // Date field (HTML5 date picker)
      case "date":
        return (
          <Input
            type="date"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={toLocalDate(fieldValue)}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      // Time field (HTML5 time picker)
      case "time":
        return (
          <Input
            type="time"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={toLocalTime(fieldValue)}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      // Select dropdown (e.g., Daily, Weekly, Monthly)
      case "select":
        return (
          <Input
            type="select"
            id={item.name}
            name={item.name}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          >
            <option value="">
              {t(item.placeholder || `Select ${item.labelName}`)}
            </option>
            {item.options && item.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {t(opt.label)}
              </option>
            ))}
          </Input>
        );

      default:
        return null;
    }
  };

  return (
    <Row>
      {labels.map((item) => {
        
        return (
          <Col sm={6} key={item.name}>
            <div className="mb-3">
              {item.labelName !== "Mobile" && (
                <label htmlFor={item.name} className="col-form-label">
                  {t(item.labelName)}
                  {item.required && <span className="text-danger"> *</span>}
                </label>
              )} 
              {/* Render the field */}
              {renderField(item)}
              {/* Display error for the main field */}
              {item.labelName !== "Mobile" && touched[item.name] && errors[item.name] &&(
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
              {item.fieldName === "icon" && touched[item.name] && errors[item.name] && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default NewsForm;